// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const LinksConfig = (translationService: any, $almaLanguages: any, $window: angular.IWindowService) => function(this: any, config: any) {
   const { site } = config
   const { alma } = config
   const { almaId } = config.info
   const link = {}

   if (almaId) {
      // Iterate over possible Alma links
      const actualLocale = $window.__locale.substring(0,2).toUpperCase()
      for (var labelNameObj of alma.enabled_links) {
         var labelName = labelNameObj.name
         if (alma.hasOwnProperty(labelName)) {
            // Extract the linkName
            var linkName = labelName.substring(0, labelName.lastIndexOf('_label'))
            var actualLink = alma[linkName]

            // collection_discovery link won't be configurable - use other links to deduce base url
            if (linkName === "collection_discovery") {
               var anyAlmaUrl = alma.ill || alma.suprima || alma.citation_linker || alma.journal_search
               var domain = (new URL(anyAlmaUrl))
               actualLink = `https://${domain.hostname}/discovery/collectionDiscovery?vid=${almaId}:Services&inst=${almaId}`
            }
        
            var lang = actualLink.match(/lang=(.{2})/)
            var linkLang = lang?.[1] || "EN"
            var almaLocale = $almaLanguages[actualLocale]
            //If almalocale exists use it, if not default to set in link
            if (almaLocale) {
               actualLink = actualLink.replace('lang=' + linkLang,'lang=' + almaLocale)
            }
            
            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            link[linkName] = {
               href: actualLink,
               label: alma[labelName]
            }
         }
      }
   }

   // @ts-expect-error TS(2339) FIXME: Property 'feedback' does not exist on type '{}'.
   link.feedback = {
      href: site.feedback_href,
      label: 'Feedback'
   }

   // @ts-expect-error TS(2339) FIXME: Property 'help' does not exist on type '{}'.
   link.help = {
      href: site.help,
      label: 'Help'
   }

   return link
}

LinksConfig.$inject = ['translationService', '$almaLanguages', '$window']

angular.module('summonApp.factories.configs')
   .factory('linksConfig', LinksConfig)
